const request = require('superagent');
import { debounce } from 'vue-debounce'
import Cookies from 'js-cookie'

export default {
    current_request: {},
    request_q: {},

    searchdrug(stext) {
        this.cancelQRequest("Qsearchdrug");
        var params = {
            'stext': stext
        }
        return this.postRequest('?action=searchdrug', params, "Qsearchdrug").then(function(json) {
                return json
            },
            function(error) {
                return error
            })
    },

    drugcomponents(drug_name) {
        this.cancelQRequest("Qdrugcomponents");
        var params = {
            'DrugName': drug_name
        }
        return this.postRequest('?action=drugcomponents', params, "Qdrugcomponents").then(function(json) {
                return json
            },
            function(error) {
                return error
            })
    },

    populardrug() {
        this.cancelQRequest("Qpopulardrug");
        var params = {}
        return this.postRequest('?action=populardrug', params, "Qpopulardrug").then(function(json) {
                return json
            },
            function(error) {
                return error
            })
    },

    pharmacy(params) {
        let new_params = {NDC: params.NDC.NDC, Quant: params.NDC.Quant, ZipCode: params.ZipCode}
        this.cancelQRequest("Qpharmacy");
        return this.postRequest('?action=pharmacy', new_params, "Qpharmacy").then(function(json) {
                return json
            },
            function(error) {
                return error
            })
    },

    submitAccessCode(invite) {
        this.cancelQRequest("QsubmitAccessCode");
        invite.LeadCode = Cookies.get('lead_code')
        return this.postJsonRequest('?action=quilityrx_accesscode', invite, "QsubmitAccessCode").then(function(json) {
                return json
            },
            function(error) {
                return error
            })
    },

    alldrugs() {
        this.cancelQRequest("Qalldrugs")
        return this.postJsonRequest('?action=alldrugs', null, "Qalldrugs").then(function(json) {
            return json
        },
        function(error) {
            return error
        })
    },

    pushQ(q, request, prom) {
        if (typeof q != 'undefined') {
            this.request_q[q] = request;
        }
    },

    pullQ(q) {
        if (typeof q != 'undefined') {
            this.request_q[q] = null;
        }
    },

    cancelQRequest(q) {
        if (typeof this.request_q[q] != 'undefined' && this.request_q[q] != null && typeof this.request_q[q].abort != 'undefined') {
            this.request_q[q].abort();
        }
    },

    getRequest(url, params, q, raw) {
        var g = this
        if (window.ajax_url != 'undefined') {
            url = window.ajax_url + url;
        }
        return new Promise((resolve, reject) => {
            g.current_request = request
                .get(url)
                .query(params)
                .set('Content-Type', 'application/x-www-form-urlencoded')
                .set('Accept', 'application/json')
                .set('Cache-Control', "no-cache")
                .type('json')
            g.pushQ(q, g.current_request, this)

            g.current_request.then(function(result) {
                    g.pullQ(q)
                    if (raw === true) {
                        resolve(result.text);
                    }
                    if (result.body != null) {
                        resolve(result.body);
                    }
                    resolve(result.text);
                })
                .catch(function(err) {
                    g.ga("error", url, "get");
                    if (err.status == 404) {
                        var msg = {
                            msg: err.response.body.message,
                            errors: "Page not found"
                        }
                        reject(msg);
                        return;
                    }
                    if (err.error) {
                        var error_message = "";
                        Object.keys(err.response.body.errors).forEach(function(k) {
                            error_message = error_message + err.response.body.errors[k] + " ";
                        })
                        var msg = {
                            msg: err.response.body.message,
                            errors: error_message,
                            error: true
                        }
                        //g.showError("Whoops! " + msg)
                        reject(msg);
                    }
                    reject(err);
                });
        })
    },

    postRequest(url, params, q, raw) {
        var g = this
        if (window.ajax_url != 'undefined') {
            url = window.ajax_url + url;
        }
        return new Promise((resolve, reject) => {
            g.current_request = request
                .post(url, params)
                .set('Content-Type', 'application/x-www-form-urlencoded')
                .set('Accept', 'application/json')
                .set('Cache-Control', "no-cache")
            g.pushQ(q, g.current_request, this)

            g.current_request.then(function(result) {
                    g.pullQ(q)
                    if (raw === true) {
                        resolve(result.text);
                    }
                    if (result.body != null) {
                        resolve(result.body);
                    }
                    resolve(result.text);
                })
                .catch(function(err) {
                    if (err.status == 404) {
                        var msg = {
                            msg: err.response.body.message,
                            errors: "Page not found"
                        }
                        reject(msg);
                        return;
                    }
                    if (err.error) {
                        var error_message = "";
                        Object.keys(err.response.body.errors).forEach(function(k) {
                            error_message = error_message + err.response.body.errors[k] + " ";
                        })
                        var msg = {
                            msg: err.response.body.message,
                            errors: error_message,
                            error: true
                        }
                        //g.showError("Whoops! " + msg)
                        reject(msg);
                    }
                    reject(err);
                });
        })
    },


    postJsonRequest(url, params, q, raw) {
        var g = this
        if (window.ajax_url != 'undefined') {
            url = window.ajax_url + url;
        }
        return new Promise((resolve, reject) => {
            g.current_request = request
                .post(url, params)
                .set('Content-Type', 'application/json')
                .set('Accept', 'application/json')
                .set('Cache-Control', "no-cache")
            g.pushQ(q, g.current_request, this)

            g.current_request.then(function(result) {
                    g.pullQ(q)
                    if (raw === true) {
                        resolve(result.text);
                    }
                    if (result.body != null) {
                        resolve(result.body);
                    }
                    resolve(result.text);
                })
                .catch(function(err) {
                    if (err.status == 404) {
                        var msg = {
                            msg: err.response.body.message,
                            errors: "Page not found"
                        }
                        reject(msg);
                        return;
                    }
                    if (err.error) {
                        var error_message = "";
                        Object.keys(err.response.body.errors).forEach(function(k) {
                            error_message = error_message + err.response.body.errors[k] + " ";
                        })
                        var msg = {
                            msg: err.response.body.message,
                            errors: error_message,
                            error: true
                        }
                        //g.showError("Whoops! " + msg)
                        reject(msg);
                    }
                    reject(err);
                });
        })
    },

}